import { X, Boxes, Search as SearchIcon } from "lucide-react";
import { CardWithImageAndHeading } from "../components/CardWithImageAndHeading";
import { SearchComponent } from "../components/Search";
import { EmptyState } from "../components/EmptyState";
import { ChangeEvent, useState, useEffect } from "react";
import { PlatformConnection } from "../types/tokens";

interface IProps {
  onClose: () => void;
  onClick: ({ id, clientId, scopes, connectionGuide, secretId, useDefaultOauthCreds }: { id: number; clientId?: string; scopes?: string; connectionGuide?: string; secretId?: string; useDefaultOauthCreds?: boolean }) => void;
  title?: string;
  connectedPlatforms: PlatformConnection[];
}

export const ConnectionsListSection = ({
  onClose,
  onClick,
  title = "Integrations",
  connectedPlatforms,
}: IProps) => {

  const [filteredPlatforms, setFilteredPlatforms] =
    useState<PlatformConnection[]>(connectedPlatforms);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  };

  useEffect(() => {
    if (searchTerm === '') {
      setFilteredPlatforms(connectedPlatforms);
    } else {
      setFilteredPlatforms(
        connectedPlatforms?.filter((platform) =>
          platform?.title?.toLowerCase().includes(searchTerm)
        ) || []
      );
    }
  }, [connectedPlatforms, searchTerm]);

  if (connectedPlatforms?.length === 0) {
    return (
      <EmptyState 
        message="No integrations available. Please activate integrations from the AuthKit dashboard."
        onClose={onClose}
        icon={Boxes}
      />
    );
  }

  return (
    <div className="flex flex-col gap-5 h-full w-full items-start overflow-y-hidden p-4">
      <X
        size={16}
        className="cursor-pointer self-end text-muted-foreground"
        style={{ width: '16px !important', height: '16px !important', minWidth: '16px', minHeight: '16px' }}
        onClick={onClose}
      />

      <h1 className="text-[22px] font-semibold leading-tight">
        {title}
      </h1>
      
      <SearchComponent onChange={handleChange} />
      
      {filteredPlatforms?.length === 0 ? (
        <div className="flex-1 w-full flex flex-col items-center justify-center gap-3">
          <SearchIcon 
            size={64}
            className="opacity-20 text-muted-foreground"
          />
          <p className="text-[13px] text-center px-8 text-muted-foreground">
            No integrations found matching your search.
          </p>
        </div>
      ) : (
        <div
          className="overflow-y-auto scrollbar-hide w-full grid grid-cols-3 gap-3"
        >
          {filteredPlatforms?.map((platform) => (
            <CardWithImageAndHeading
              key={platform?.connectionDefId || platform?.connectionDefinitionId}
              id={(platform?.connectionDefId || platform?.connectionDefinitionId) ?? 0}
              onClick={(id: number) =>
                onClick({ id, clientId: platform.clientIdDisplay || platform?.secret?.clientId, secretId: platform?.secretId || platform?.secretsServiceId, connectionGuide: platform?.guide, useDefaultOauthCreds: platform?.useDefaultOauthCreds })
              }
              image={platform?.image}
              heading={platform?.title}
            />
          ))}
        </div>
      )}
    </div>
  );
};
